import contactForm from '@/api/contact_forms'

export default ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    contactForm.deleteContactFormById(result => {
      resolve(result.data.data)
    }, param)
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/contact_forms/actions/deleteContactFormById.js